const Prerequisites = ({ prerequisites }) => {
  return (
    <>
      <div className="card bg-gradient-glass backdrop-filter-20px border-common">
        <div className="card-body p-4">
          <h5 className="text-white fw-bold mb-3">✅ Prerequisites</h5>
          <ul className="list-unstyled">
            {prerequisites && prerequisites.length > 0 ? (
              prerequisites.map((item, index) => (
                <li className="text-white mb-2" key={index}>
                  <span className="text-success me-2">✓</span>
                  {item}
                </li>
              ))
            ) : (
              <li className="text-white-50">No prerequisites listed</li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default Prerequisites;
